import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { cn } from "@util/helpers";

type BookletProps = {
  /** The card prop to be displayed. */
  cardProp: ComponentProps<typeof Card>;
  /** Optional additional styling for the component. */
  className?: string;
};

/**
 * Booklet component to display booklet card for Singapore Budget 2025 page.
 * Figma: https://www.figma.com/design/FZiuxiCLQaNXAJmLRtAAY9/BUDGET-2025--WEB---APP---NL-?node-id=8518-386960&t=PUAyvdavKczeZd7x-4
 */
const Booklet = ({ className, cardProp }: BookletProps): React.ReactElement => {
  const variant: CardVariations = {
    image: {
      position: "left",
      width: "w-3/10",
      filters: {
        w: ImagePresets.MICRO,
        dpr: 1,
        f: "webp",
      },
    },
    content: {
      width: "w-7/10",
      extraClass: "pl-4",
    },
    title: {
      size: "text-lg",
      color: "text-gray-850",
      extraClass: cn("font-bold font-lct"),
    },
  };

  const attachmentLink = cardProp.link;

  if (!attachmentLink) return <></>;

  return (
    <div className={className} data-testid="budget-2025-booklet-component">
      <BlockTitle
        text="MTI'S BUSINESS BUDGET BOOKLET 2025"
        rootClassName="mb-4 !text-lg lg:!text-3xl"
      />

      <Card {...cardProp} variations={variant} />
    </div>
  );
};

export default Booklet;
